'use client'

import { useEffect } from 'react'
import { useLocale } from 'next-intl'

/**
 * Component that tracks the current locale in sessionStorage
 * This helps the auth page detect the language when navigating from landing pages
 */
export function LanguageSessionTracker() {
  const locale = useLocale()

  useEffect(() => {
    // Store current locale in sessionStorage for auth page detection
    sessionStorage.setItem('landing-language', locale)
    console.log('[LanguageSessionTracker] Stored locale in session:', locale)
  }, [locale])

  return null // This component doesn't render anything
}